import React, { PureComponent } from 'react';
import Popup from "./Popup";

class ButtonConfirmar extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { getCodigo, tituloPopUp, ajuste, tituloButton1, tituloButton2, confirmarAjuste, ajusteEstados, cargoEstados } = this.props;
        return (<Popup
            clave={"popup-confirmar-" + ajuste.Id}
            ajuste={ajuste}
            titulo={tituloPopUp}
            confirmar={confirmarAjuste}
            tituloButton1={tituloButton1}
            tituloButton2={tituloButton2}
            ajusteEstados={ajusteEstados}
            getCodigo={getCodigo}
            cargoEstados={cargoEstados}>
            <a className="clickable none-text-decoration ingresoAjustes-icono-confirmacion" data-toggle="dropdown"></a>
        </Popup>);
    }
}

export default ButtonConfirmar;